export default {"src":"/_next/static/media/coin-circle-gray.3c794b80.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};